import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import ConversationPane from '../components/ConversationPane';
import SettingsDrawer from '../components/SettingsDrawer';
import api from '../lib/api';
import { getUser, clearSession } from '../lib/auth';
import { getSocket, disconnectSocket } from '../lib/socket';
import { applyTheme } from '../lib/prefs';

// /app shell: sidebar + conversation pane. No posts/feed — chats and groups
// only, per spec. Responsive: one pane at a time on small screens.
export default function MessengerPage() {
  const navigate = useNavigate();
  const [active, setActive] = useState(null);
  const [showSettings, setShowSettings] = useState(false);
  const [connected, setConnected] = useState(true);

  // Apply the saved theme + reflect live socket connection state.
  useEffect(() => {
    applyTheme();
    const socket = getSocket();
    setConnected(socket.connected);
    const onConnect = () => setConnected(true);
    const onDisconnect = () => setConnected(false);
    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
    };
  }, []);

  const logout = async () => {
    if (!window.confirm('Disconnect this device?')) return;
    const user = getUser();
    try {
      if (user?.qrToken) {
        await api.post('/api/qr/disconnect-session', { qrToken: user.qrToken });
      }
    } catch (err) {
      console.error('Disconnect failed:', err);
    } finally {
      clearSession();
      disconnectSocket();
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="h-screen flex flex-col bg-white text-ink">
      {!connected && (
        <div className="bg-amber-500 text-white text-center text-sm py-1 shrink-0">
          Reconnecting…
        </div>
      )}
      <div className="flex-1 flex min-h-0">
        {/* Sidebar — full width on mobile, hidden there once a chat is open */}
        <div
          className={`h-full w-full md:w-[340px] md:shrink-0 ${
            active ? 'hidden md:block' : 'block'
          }`}
        >
          <Sidebar
            activeId={active?.id}
            onSelect={setActive}
            onOpenSettings={() => setShowSettings(true)}
          />
        </div>
        {/* Conversation — hidden on mobile until a chat is open */}
        <div className={`h-full flex-1 min-w-0 ${active ? 'block' : 'hidden md:block'}`}>
          <ConversationPane conversation={active} onBack={() => setActive(null)} />
        </div>
      </div>

      {showSettings && (
        <SettingsDrawer onClose={() => setShowSettings(false)} onLogout={logout} />
      )}
    </div>
  );
}
